export default __webpack_public_path__ + "5eac19beb641037ab217246be10ca497.svg";